import React, { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import FormattedPrice from 'src/components/BookingFlow/modules/ServiceSelect/FormattedPrice/FormattedPrice';
import SecondaryButton from 'src/components/form-components/SecondaryButton/SecondaryButton';
import Reservation from 'src/components/Reservations/Reservation';
import { Section } from 'src/components/Section';
import { AppContext } from 'src/contexts/AppContext';
import { BookingContext } from 'src/contexts/BookingFlowContext';
import { ReservationEndContext } from 'src/contexts/ReservationEndContext';
import { reservationModelToRequest } from 'src/services/api/reservation';
import globalMessages from 'src/services/globalMessages';
import { getPaymentNeedWithPrice } from '../../functions/helperFunctions';

const messages = defineMessages({
    addNewReservation: {
        id: 'addNewReservation',
        defaultMessage: 'További időpont hozzáadása'
    },
    reservations: {
        id: 'reservations',
        defaultMessage: 'Időpontok'
    }
});

const ReservationsSection: React.FC = () => {

    const { company } = useContext(AppContext);
    const { reservations, actions } = useContext(BookingContext);
    const { hasOnlinePocket, displayedSubtotal } = useContext(ReservationEndContext);

    return (
        <Section title={messages.reservations}>
            {reservations.map((reservation, i) =>
                <Reservation
                    key={i}
                    reservation={reservationModelToRequest(reservation)}
                    displayReadMore={false}
                    canModify={true}
                    needsPayment={getPaymentNeedWithPrice(company?.PaymentSettings.IsPaymentEnabled,
                        (reservation.service ? reservation.service : reservation.timetable?.service))}
                    onEdit={() => actions.setActiveReservation(i)}
                    onDelete={() => actions.removeReservation(i)}
                    isReservationEnd={true}
                />
            )}
            <div className={'reservation-end__container'}>
                {!company?.IsCartDisabled &&
                    <SecondaryButton className='reservation-end__add-new-reservation'
                        onClick={actions.addNewReservation}
                        caption={messages.addNewReservation} />
                }
                {(company?.PaymentSettings.IsPaymentEnabled && hasOnlinePocket && displayedSubtotal && displayedSubtotal.Price !== 0) &&
                    <div className='reservation-end__subtotal'>
                        <FormattedMessage {...globalMessages.subtotal} />
                        <FormattedPrice value={displayedSubtotal.Price} currency={displayedSubtotal.Currency} />
                    </div>
                }
            </div>
        </Section>
    );
}

export default ReservationsSection;